/**
 * Chemplast `planner/saveplan` / `updateprocess` expect a **flat** `ChannelProgram` JSON body.
 * Backend removed `MaterialBatchNumber` — strip it here so every caller stays aligned.
 *
 * If a payload was accidentally nested as `{ request: dto }`, merge dto to root once (no outer wrapper).
 *
 * `FromDate_Time` / `ToDate_Time` in SQL come from `since` / `till` only — no extra date fields required in JSON.
 *
 * @param {Record<string, unknown>} [data]
 * @returns {Record<string, unknown>}
 */
export function sanitizeSavePlanPayload(data) {
  let flat = data == null ? {} : { ...data };

  if (flat.request && typeof flat.request === 'object' && !Array.isArray(flat.request)) {
    const inner = { ...flat.request };
    delete flat.request;
    flat = { ...inner, ...flat };
  }
  if (flat.Request && typeof flat.Request === 'object' && !Array.isArray(flat.Request)) {
    const inner = { ...flat.Request };
    delete flat.Request;
    flat = { ...inner, ...flat };
  }

  delete flat.request;
  delete flat.Request;
  delete flat.materialBatchNumber;
  delete flat.MaterialBatchNumber;

  if (Array.isArray(flat.processParts)) {
    flat.processParts = flat.processParts.map(part => {
      if (!part || typeof part !== 'object') return part;
      const p = { ...part };
      delete p.materialBatchNumber;
      delete p.MaterialBatchNumber;
      return p;
    });
  }

  if (flat.id != null && typeof flat.id !== 'string') {
    flat.id = String(flat.id);
  }

  return flat;
}

/** Used by planner thunks before POST — keeps work ticket id/title consistent (single leading W). */
export function normalizeSavePlanWorkTicketFields(flat) {
  if (flat == null || typeof flat !== 'object') return flat;
  if (typeof flat.title === 'string') {
    flat.title = flat.title.replace(/^W+/i, '').trim();
  }
  if (flat.id != null && typeof flat.id === 'string') {
    const idStr = flat.id.trim();
    if (/^\d+$/.test(idStr)) {
      flat.id = idStr;
    } else {
      const ticket = idStr.replace(/^W+/i, '').trim();
      if (ticket) flat.id = `W${ticket}`;
    }
  }
  return flat;
}
